export default {
      id: "ic-soc-facebook-usage",
      viewBox: "0 0 30 31",
      url: "../dist/images/" + "sprite.svg#ic-soc-facebook-usage",
      toString: function () {
        return this.url;
      }
    }